import { Box } from "@mui/material";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TextBox from "../../components/input/TextBox";
import { Company } from "../../db_access/company";
import muiSytle from "../../style/components-style/muiStyle";
import ManageColleagues from "./ManageColleagues";
const ProfileDashboard = () => {
  const { t } = useTranslation();
  const [company, setCompany] = useState({ name: "", address: "" });
  const getMyCompany = () => {
    Company.get_mine()
      .then((res) => res.json())
      .then((data) => data.length > 0 && setCompany(data[0]));
  };
  const updateMyCompany = (e, field) => {
    const body = { ...company, [field]: e.target.value };
    setCompany(body);
    Company.update_mine(body).finally(() => {});
  };
  useEffect(() => getMyCompany(), []);
  return (
    <Box sx={{ ...muiSytle.mainContainer, pt: 1 }}>
      {/* 
      <Box sx={muiSytle.pageTitleContainer}>
        <Box>
          <Box>
            <Typography variant="Page Title">
              {t("Profile")} - {company.name}
            </Typography>
          </Box>
          <Box>
            <Typography variant="Page Subtitle">{t("Profile")}</Typography>
          </Box>
        </Box>
      </Box>
      */}
      <Box sx={{ display: "flex", flexWrap: "wrap", paddingX: 1, paddingY: 2, gap: 2 }}>
        <Box sx={{ flex: 1, minWidth: "300px" }}>
          <TextBox label={"Company Name"} value={company.name} onChange={(e) => updateMyCompany(e, "name")} />
        </Box>
        <Box sx={{ flex: 1, minWidth: "300px" }}>
          <TextBox label={"Company Address"} value={company.address} onChange={(e) => updateMyCompany(e, "address")} />
        </Box>
      </Box>
      <Box>
        <ManageColleagues />
      </Box>
    </Box>
  );
};

export default ProfileDashboard;
